import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data';
import { AntdModal, AntdModalProps, AntdTypography } from '@ui/components';

const { Text } = AntdTypography;

interface ConfirmationModalProps extends AntdModalProps {
  isLoading?: boolean;
  message: string | ReactElement;
}

export const ConfirmationModal = ({
  open,
  onCancel,
  isLoading,
  title,
  message,
  okText,
  cancelText,
  ...props
}: ConfirmationModalProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  return (
    <AntdModal
      open={open}
      title={title}
      cancelText={cancelText ?? t('patient:common.cancel')}
      cancelButtonProps={{ disabled: isLoading }}
      okText={okText ?? t('patient:common.remove')}
      okButtonProps={{ loading: isLoading }}
      onCancel={onCancel}
      {...props}
    >
      <Text>{message}</Text>
    </AntdModal>
  );
};
